import cn from 'classnames';
import { BadgeArt, BadgeShareButton } from '@/features/Badges';
import type { IStudentBadge } from '@/entities/Badges';

interface BadgeCardProps {
  badge: IStudentBadge;
}

// Плитка одинаковая в обоих состояниях, различаются арт и цвет текста
const TILE_GRADIENT =
  'linear-gradient(102.72deg, rgba(33, 29, 85, 0.05) 2.63%, rgba(99, 0, 0, 0.05) 104.31%)';

export const BadgeCard = ({ badge }: BadgeCardProps) => {
  // У полученного подсказки нет — сервер отдаёт её только для запертых.
  const caption = badge.isEarned ? badge.description : (badge.unlockHint ?? badge.description);

  return (
    <li className="flex w-[210px] flex-col items-center gap-3">
      <div
        className="relative flex h-[200px] w-[210px] shrink-0 items-center justify-center rounded-2xl"
        style={{ backgroundImage: TILE_GRADIENT }}
      >
        <BadgeArt badge={badge} />
        {/* Делиться можно только полученным: у запертого под плиткой подсказка, как его взять.
            Положение задаём обёрткой: absolute и relative на одном узле спорят между собой. */}
        {badge.isEarned && (
          <span className="absolute right-3 top-3">
            <BadgeShareButton badge={badge} />
          </span>
        )}
      </div>
      <div
        className={cn(
          'flex w-full flex-col items-center gap-1.5 text-center text-sm',
          badge.isEarned ? 'text-black' : 'text-grey-secondary',
        )}
      >
        <p className="font-bold leading-[1.4]">{badge.title}</p>
        {caption && <p className="min-h-[34px] leading-[1.2]">{caption}</p>}
      </div>
    </li>
  );
};
